import { Grid, IconButton } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { useEffect, useState } from "react";
import DialogConfirm from "../../../../components/common/DialogConfirm";
import SubmitButton from "../../../../components/common/SubmitButton";
import { useTranslation } from "../../../../hooks/useTranslation";
import useVehicle from "../../../../hooks/useVehicle";
import { EntrantTabIndex } from "../../../../utils/tabIndex";
import { VehicleData } from "../Vehicle";
import DriverLicenseSection from "./DriverLicenseSection/DriverLicenseSection";
import InsuranceSection from "./InsuranceSection/InsuranceSection";
import { useStyles } from "./NewVehicleStyles";
import {setOpenedVehicleSection} from "../../../../redux/actions/registerExitActions";
import {useDispatch} from "react-redux";

type NewVehicleProps = {
  goBack: () => void,
  vehicle: VehicleData,
  onSaved?: () => void,
};

const NewVehicle = ({ goBack, vehicle, onSaved }: NewVehicleProps) => {
  const classes = useStyles();
  const { addNewVehicle, updateExistingVehicle, loading } = useVehicle();
  const [isModified, setIsModified] = useState(false);
  const [vehicleModified, setVehicleModified] = useState<VehicleData | any>(
    null
  );
  const [openDialogError, setOpenDialogError] = useState(false);
  const [errors, setErrors] = useState<any[]>([]);
  const { t, BundleKey } = useTranslation();
  const appDispatch = useDispatch();

  const add = async () => {
    let flag = true;
    let errors: string[] = [];
    if (vehicleModified.plate === "") {
      errors.push(t(BundleKey.ERROR_VEHICLE_PLATE_MUST));
      flag = false;
    }

    if (flag) {
      if (!vehicle.id) {
        try {
          await addNewVehicle(vehicleModified);
          onSaved?.();
          goBack();
        } catch (error) {
          setErrors([error instanceof Error ? error.message : "No se pudo crear el vehículo."]);
          setOpenDialogError(true);
        }
      } else {
        try {
          await updateExistingVehicle(vehicleModified);
          onSaved?.();
          goBack();
        } catch (error) {
          setErrors([error instanceof Error ? error.message : "No se pudo actualizar el vehículo."]);
          setOpenDialogError(true);
        }
      }
    } else {
      setErrors(errors);
      setOpenDialogError(true);
    }
  };

  const onChangeModified = () => {
    setIsModified(true);
    appDispatch(setOpenedVehicleSection(true));
  };

  const onChangeVehicle = (vehicleData: VehicleData) => {
    setIsModified(true);
    setVehicleModified(vehicleData);
    appDispatch(setOpenedVehicleSection(true));
  };

  useEffect(() => {
    setVehicleModified(vehicle);
  }, []);

  const handleCloseError = () => {
    setOpenDialogError(false);
    setErrors([]);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <IconButton
            aria-label="delete"
            className={classes.margin}
            size="medium"
            onClick={goBack}
          >
            <ArrowBackIcon fontSize="inherit" />
          </IconButton>
        </Grid>
        <Grid item xs={12} sm={6}>
          {vehicleModified ? (
            <InsuranceSection
              modified={onChangeVehicle}
              data={vehicleModified}
            />
          ) : null}
        </Grid>

        <Grid item xs={12} sm={6}>
          <DriverLicenseSection modified={onChangeModified}>
            <SubmitButton
              color="primary"
              loading={loading}
              onClick={add}
              tabIndex={EntrantTabIndex.select}
            >
              {!vehicle.id
                ? t(BundleKey.ACTION_ADD)
                : isModified
                ? t(BundleKey.ACTION_UPDATE)
                : t(BundleKey.ACTION_SELECT)}
            </SubmitButton>
          </DriverLicenseSection>
        </Grid>
      </Grid>

      <DialogConfirm
        openDialog={openDialogError}
        handleConfirm={handleCloseError}
        handleClose={handleCloseError}
        message={
          <>
            {errors.map((item, index) => (
              <span key={index}>{item}</span>
            ))}
          </>
        }
        title={t(BundleKey.DIALOG_FIELDMISSING_TITLE)}
        titleButtonOk={t(BundleKey.ACTION_ACCEPT)}
      />
    </>
  );
};

export default NewVehicle;
